import { render } from "./MonitorCompletedJobsWidget.vue?vue&type=template&id=54e09a60&scoped=true"
import script from "./MonitorCompletedJobsWidget.vue?vue&type=script&lang=js"
export * from "./MonitorCompletedJobsWidget.vue?vue&type=script&lang=js"

import "./MonitorCompletedJobsWidget.vue?vue&type=style&index=0&id=54e09a60&scoped=true&lang=css"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e09a60"]])

export default __exports__